import { entities } from "sbtech-sports-data-api-client";
import { Selection } from "../../data";
import { enableLowOdds } from "../../helpers";
export class SelectionParser {
    static get instance() {
        if (!SelectionParser._instance) {
            SelectionParser._instance = new SelectionParser();
        }
        return SelectionParser._instance;
    }
    parse(selection, existingSelection, uiPreferences) {
        const hasEnableLowOdds = enableLowOdds(selection.trueOdds, uiPreferences.enableLowOdds);
        const existingSelectionObj = this.getExistingSelectionObj(selection, existingSelection, uiPreferences);
        let title = existingSelectionObj.title, odds = selection.displayOdds[uiPreferences.oddStyle], isDisabled = selection.isDisabled;
        if (hasEnableLowOdds) {
            title = odds = "";
            isDisabled = true;
        }
        return new Selection({
            id: selection.id,
            title,
            displayOdds: selection.displayOdds,
            odds,
            trueOdds: selection.trueOdds,
            lineGroupId: existingSelectionObj.lineGroupId,
            outcomeType: existingSelectionObj.outcomeType,
            points: existingSelectionObj.points,
            isDisabled,
            isSelected: false,
            isSwapped: uiPreferences.isSwapped,
            sbtechId: selection.metadata.idSBTech,
            betslipLine: selection.betslipLine,
            group: selection.group,
            tags: selection.tags,
            status: selection.status,
            participantMapping: selection.participantMapping
        });
    }
    getOddsForOddStyle(selection, oddStyle) {
        return selection.displayOdds[oddStyle];
    }
    getOutcomeType(outcomeType, isSwapped) {
        if (outcomeType === entities.OutcomeType.Home) {
            return isSwapped
                ? entities.OutcomeType.Away
                : entities.OutcomeType.Home;
        }
        else if (outcomeType === entities.OutcomeType.Away) {
            return isSwapped
                ? entities.OutcomeType.Home
                : entities.OutcomeType.Away;
        }
        return outcomeType ? outcomeType.toString() : "";
    }
    getExistingSelectionObj(selection, existingSelection, uiPreferences) {
        if (existingSelection) {
            return {
                title: existingSelection.title,
                lineGroupId: existingSelection.lineGroupId,
                outcomeType: this.getOutcomeType(existingSelection.outcomeType, uiPreferences.isSwapped),
                points: existingSelection.points
            };
        }
        return {
            title: selection.name,
            lineGroupId: selection.group.toString(),
            outcomeType: this.getOutcomeType(selection.outcomeType, uiPreferences.isSwapped),
            points: (selection.points || 0)
        };
    }
}
//# sourceMappingURL=SelectionParser.js.map